module.exports = {
  DOMAIN: process.env.VUE_APP_DOMAIN || 'https://qa4-chat-api.fishersci.com',
  GATEWAY_LOCATION: process.env.VUE_APP_GATEWAY_LOCATION || 'https://qa4-chat-api.fishersci.com/api/store/chat/fs',
  API_ELIGIBILITY: process.env.VUE_APP_API_ELIGIBILITY || '/api/v1/session/eligibility',
  API_AGENT_AVAILABILITY: process.env.VUE_APP_API_AGENT_AVAILABILITY || 'api/store/chat/rule-engine/chat/availability',
  API_MEDALIA_AVALABILITY: process.env.VUE_APP_API_SESSION_MEDALIA || '/api/store/chat/session/medalia',
  start_suggestions: [], // <- array of suggestions, displayed at the start screen
  fallback_lang: 'en', // <- fallback language code, if history mode or network is unavailable
  voice: 'native', // <- voice of Text-To-Speech; for reference, see: https://developer.mozilla.org/en-US/docs/Web/API/SpeechSynthesisVoice/voiceURI
  codecs: { // <- tells browser the mime types of audio in Dialogflow
    OUTPUT_AUDIO_ENCODING_UNSPECIFIED: 'audio/wav',
    OUTPUT_AUDIO_ENCODING_LINEAR_16: 'audio/wav',
    OUTPUT_AUDIO_ENCODING_MP3: 'audio/mpeg',
    OUTPUT_AUDIO_ENCODING_OGG_OPUS: 'audio/ogg'
  },

  enableEmoji: true,
  emojiLocationSet: {
    us: ['👍', '😊', '😔'],
    default: ['👍', '😊', '😔']
  }
}
